import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { searchRouteInfos } from '../components/Layout/Menu/helper/searchRouteInfos';
import { useAppDispatch, useAppSelector } from '../reducer/hooks';
import { selectPermissions } from '../reducer/profileSlice';
import { setView } from '../reducer/stuffSlice';
import useTranslation from './useTranslation';

export default function useRoutePermission() {
  const dispatch = useAppDispatch();
  const pathname = useLocation().pathname.replace('/', '');

  const { translate } = useTranslation();
  const permissionList = useAppSelector(selectPermissions);

  const getTitleKey = () => {
    return searchRouteInfos('route', pathname)?.key || 'homepage';
  };

  const key = getTitleKey();
  const viewTitle = translate(`menu.${key}`);

  const hasPermission = (key: string) => permissionList.includes(String(key).toLowerCase());

  useEffect(() => {
    dispatch(setView(viewTitle));
  }, [viewTitle]);

  const hasRoutePermission = (key: string) => {
    const { permission } = searchRouteInfos('key', key) || {};

    if (!permission) return true;

    return hasPermission(permission || '');
  };

  return { hasRoutePermission, viewTitle };
}
